/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';
const TableCellContext = createContext(null);
export const TableCellProvider = TableCellContext.Provider;
export const useTableCell = () => useContext(TableCellContext);
//# sourceMappingURL=TableCellContext.js.map